import { AxiosPromise } from "axios";

const API_PATH = process.env.REACT_APP_API_URL;

type API = {
  get: (url: string) => AxiosPromise;
  post: (url: string, payload: any) => AxiosPromise;
  put: (url: string, payload: any) => AxiosPromise;
  delete: (url: string) => AxiosPromise;
};

const rolesandpermissions = (api: API) => {
  const getAllRoles = () => api.get(API_PATH + "/counselor/getAllCounselor");
  const addUserRoles = (payload: any) =>
    api.post(API_PATH + "/counselor/addCounselor", payload);
  const editUserRoles = (id: string, payload: any) =>
    api.put(API_PATH + `/counselor/editCounselor/${id}`, payload);
  const deleteUserRole = (id: string) =>
    api.delete(API_PATH + `/counselor/deleteCounselor/${id}`);
  const getAllLogs = () => api.get(API_PATH + "/logs/logs");

  return {
    getAllRoles,
    addUserRoles,
    editUserRoles,
    deleteUserRole,
    getAllLogs,
  };
};

export default rolesandpermissions;
